module.exports = __webpack_public_path__ + "img/no_zone_selected.8d0fffd3.svg";